import { Slider } from 'components/Pages/Home';
import RichText from 'components/ui/ContentBlocks/RichText';
import type { Doctor } from 'types/MedicalStaff';
import type { Document } from '@contentful/rich-text-types';

type Props = {
  description?: Document;
  headline?: string;
  items: [];
};

const Doctors = ({ description, headline, items }: Props): JSX.Element => {
  const sliderItems = items.filter(Boolean).map((item: Doctor) => {
    return {
      slug: item.slug,
      name: `${item.title ? item.title : ''} ${item.firstName} ${
        item.lastName
      }${item.postTitle ? `, ${item.postTitle}` : ''}`,
      image: item.doctorImage?.url,
      treatmentsPerformedLastYear: item.treatmentsPerformedLastYear,
      yearsOfExperience:
        (new Date().getFullYear() as number) -
        (item.yearsOfExperienceAsDoctor as number),
      location:
        `${item.clinic?.name},${item.clinic?.city.name},${item.clinic?.city.country.name}` ||
        '',
      qunoscore: item.qunoscore,
    };
  });

  const sortedSliderItems = sliderItems.sort((a, b) => {
    if (a.qunoscore && b.qunoscore && a.qunoscore > b.qunoscore) {
      return -1;
    }

    if (a.qunoscore && b.qunoscore && a.qunoscore < b.qunoscore) {
      return 1;
    }

    return 0;
  });

  return (
    <div className="border-t border-silver-light">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-2-188r lg:text-1-938r mb-2 px-5 lg:px-4">
          {headline}
        </h2>
        {description && (
          <div className="text-charcoal mb-12 leading-8 md:leading-normal px-5 lg:px-4">
            <RichText fields={description} />
          </div>
        )}
        <div className="pl-3 lg:px-4">
          <Slider
            type="popularDoctors"
            items={sortedSliderItems}
            allowCenterMode={false}
            showFade={false}
            sliderItemClasses="mx-1 md:mx-3"
            nonSliderItemClasses="mx-1 md:mx-3"
            sliderConfig={{
              threshold: 2,
              noFullWidth: true,
              itemWidth: 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4',
              responsive: {
                superLargeDesktop: {
                  breakpoint: { max: 4000, min: 3000 },
                  items: 4,
                  partialVisibilityGutter: 40,
                },
                desktop: {
                  breakpoint: { max: 2999, min: 1024 },
                  items: 4,
                  partialVisibilityGutter: 40,
                },
                tablet: {
                  breakpoint: { max: 1023, min: 768 },
                  items: 2,
                  partialVisibilityGutter: 40,
                },
                mobile: {
                  breakpoint: { max: 767, min: 0 },
                  items: 1,
                  partialVisibilityGutter: 60,
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Doctors;
